import { CardLoader, ListPagination } from 'components/organisms'
import { OUTBOUND_DEALS_COLUMNS } from './outbound-deals-url-params-table-columns'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import OutboundDealsUrlParamsTableRow from './outbound-deals-url-params-table-row'

const propTypes = {
  tableProps    : PropTypes.object,
  deals         : PropTypes.array,
  pagination    : PropTypes.object,
  onPageChange  : PropTypes.func,
  isLoading     : PropTypes.bool,
  onClickRow    : PropTypes.func,
  onSelectRow   : PropTypes.func,
  hiddenColumns : PropTypes.array
}

const defaultProps = {
  isLoading     : true,
  onPageChange  : () => { },
  hiddenColumns : []
}

/**
 * Table to display specific Deals data
 * @param {Object} tableProps - object of tableProps that contains size, responsive, etc
 * @param {Array<Object>} deals - array of Deals
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Boolean} isLoading - boolean for withLoader animation
 * @param {Function} onPageChange - function that will handle page change
 * @param {Function} onClickRow - function to navigate to deal detail page when admin click on data row
 * @param {Array<String>} hiddenColumns - Array of hidden columns name
 */
const OutboundDealsUrlParamsTable = ({
  tableProps,
  deals,
  pagination,
  isLoading,
  onPageChange,
  onClickRow,
  hiddenColumns
}) => {
  const outboundDealsColumns      = OUTBOUND_DEALS_COLUMNS.filter((column) => !hiddenColumns.includes(column.name))
  const outboundDealsHeaderLength = outboundDealsColumns.length
  const totalColumns                  = outboundDealsHeaderLength
  const isDealsNotFound        = (deals?.length ?? 0) === 0

  const TableContent = () => (
    <>
      <Table { ...tableProps }>
        <thead>
          <tr>
            {
              outboundDealsColumns.map((column) => (
                <th key={ `outbound-deals-column-${column.name}` } scope="col">{ column.label }</th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            deals?.map((deal) => (
              <OutboundDealsUrlParamsTableRow
                key={ `outbound-deals-data-${deal.id}` }
                deal={ deal }
                onClickRow={ onClickRow }
                hiddenColumns={ hiddenColumns }
                outboundDealsColumns={ outboundDealsColumns }
              />
            ))
          }
          {
            isDealsNotFound && (
              <tr>
                <td
                  colSpan={ totalColumns }
                  className='bg-warning text-white'
                >
                  <i className='fas fa-info-circle mr-3' />
                  { 'Outbound Deals tidak ditemukan.' }
                </td>
              </tr>
            )
          }
        </tbody>
      </Table>
    </>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <ListPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}

OutboundDealsUrlParamsTable.propTypes    = propTypes
OutboundDealsUrlParamsTable.defaultProps = defaultProps

export default OutboundDealsUrlParamsTable